import { render } from "./CategoryCountIcon.vue?vue&type=template&id=1308d284&scoped=true"
import script from "./CategoryCountIcon.vue?vue&type=script&lang=js"
export * from "./CategoryCountIcon.vue?vue&type=script&lang=js"

import "./CategoryCountIcon.vue?vue&type=style&index=0&id=1308d284&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1308d284"]])

export default __exports__